import React from 'react';
import { AlertCircle, ArrowRight, CheckCircle2, Info, TriangleAlert } from 'lucide-react';
import Button from './design-system/Button';
import styles from './FothToast.module.scss';

const ICONS = {
  success: CheckCircle2,
  error: AlertCircle,
  warning: TriangleAlert,
  info: Info,
};

const FothToast = ({
  tone = 'info',
  title,
  description,
  action,
  closeToast,
}) => {
  const Icon = ICONS[tone] || ICONS.info;
  const handleAction = (event) => {
    closeToast?.();
    action?.onClick?.(event);
  };

  return (
    <div className={`${styles.toast} ${styles[`tone-${tone}`]}`}>
      <span className={styles.iconWrap} aria-hidden="true">
        <Icon size={18} strokeWidth={2} />
      </span>
      <div className={styles.content}>
        {title && <strong className={styles.title}>{title}</strong>}
        {description && <span className={styles.description}>{description}</span>}
        {action && (
          <Button
            variant="ghost"
            size="sm"
            to={action.to}
            href={action.href}
            onClick={handleAction}
            className={styles.action}
            aria-label={action.label}
          >
            {action.label}
            <ArrowRight size={15} aria-hidden="true" />
          </Button>
        )}
      </div>
    </div>
  );
};

export default FothToast;
